import { formatEuro, formatQty } from "../lib/format";
import type { HistoryRow } from "./HistoryTable";
import { groupSummary } from "./historyGroups";
import SignedDeviation from "./SignedDeviation";

export default function HistoryGroupHeading<T>({ name, rows, collapsed, onToggle, showPriceMetrics = true }: {
  name: string; rows: readonly HistoryRow<T>[]; collapsed: boolean; onToggle: () => void; showPriceMetrics?: boolean;
}) {
  const summary = groupSummary(rows);
  return <div data-history-group={name} className="min-w-0 break-words">
    <button type="button" onClick={onToggle} aria-expanded={!collapsed}
      className="flex w-full flex-wrap items-baseline justify-between gap-2 text-left text-sm">
      <span className="min-w-0 font-medium text-slate-900"><span className="mr-1.5 text-xs text-slate-500">{collapsed ? "▸" : "▾"}</span>{name}</span>
      <span className="text-xs text-slate-600">
        {summary.count} {summary.count === 1 ? "Position" : "Positionen"}{showPriceMetrics ? ` · ${summary.qty === null ? "Menge nicht summierbar" : `${formatQty(summary.qty)} ${summary.uom}`}` : ""} · {summary.total === null ? "Summe unvollständig" : formatEuro(summary.total)}
      </span>
    </button>
    {showPriceMetrics ? <details className="mt-1 text-xs text-slate-600">
      <summary className="w-fit cursor-pointer text-emerald-800">Preiskennzahlen</summary>
      <dl className="mt-2 flex flex-wrap gap-x-8 gap-y-3">
        <div><dt>Durchschnitt / {summary.priceUom ?? "Einheit"}</dt><dd className="mt-1 text-sm font-medium text-slate-900">{formatEuro(summary.average)}</dd></div>
        <div><dt>Bester Preis / {summary.priceUom ?? "Einheit"}</dt><dd className="mt-1 text-sm font-medium text-slate-900">{formatEuro(summary.best)}</dd></div>
        <div><dt>Abweichung gesamt</dt><dd className="mt-1 text-sm"><SignedDeviation layout="inline" amount={summary.difference} percent={summary.percent} /></dd></div>
      </dl>
      <p className="mt-2">{summary.comparedCount ? `${summary.comparedCount} von ${summary.count} Positionen: Rechnungen mit positiver Menge und vergleichbarer Einheit. Ø nach Menge gewichtet; Abweichung nur bei passender Einheit der gewählten Referenz.` : "Kein gemeinsamer Preisvergleich möglich: vergleichbare Rechnungspositionen mit bekannter Einheit und positiver Menge fehlen."}</p>
    </details> : null}
  </div>;
}
